import { format, parseISO } from 'date-fns';

/**
 * Formats a date string.
 * Defaults to "MMM dd, yyyy" (e.g. "Sep 30, 2024") if no format is provided.
 * Returns an empty string if the date is invalid OR if the provided dateFormat is invalid.
 */
export const formatDate = (
	dateString: string | null | undefined,
	dateFormat: string = 'MMM dd, yyyy'
): string => {
	if (!dateString) return '';

	try {
		const date = parseISO(dateString);

		if (isNaN(date.getTime())) {
			return '';
		}

		return format(date, dateFormat);
	} catch (_: unknown) {
		return '';
	}
};
